export default "__VITE_ASSET__iLxS2BybQgfN$A5IDvQgVA__"